<template>
  <APP_LOGIN v-if="application == 'login'" :from="from" />

  <template v-if="login && AppCanLoad">
    <!-- /// APLICATION /// -->

    <APP_ADMIN v-if="application == 'web'" />
    <APP_WEB v-if="application == 'web'" />

    <APP_PILOTLOGIN v-if="application == 'pilotlogin'" />
    <APP_MILESTONE v-if="application == 'milestone'" />
    <APP_POPUP v-if="application == 'popup'" />

    <!-- ////////// -->

    <DEVICE_APP />
    <EXTERNAL_CONTROL />
    <DEVICE_CHEACKLIST />

    <template v-if="mainMapReady && !isPilotLogin">
      <Teleport :to="positionMap">
        <MapVue />
      </Teleport>
    </template>
  </template>

  <CONFIRM :confirm_data="confirm_data" v-if="confirm_data != false" />
</template>

<script>
import { ref, getCurrentInstance } from "vue";
import { toast } from "vue3-toastify";

import Timer from "@/utils/Timer";
import User from "@/utils/User";
import API from "@/utils/API";

/** -------- CONSTANCE -------- */

import { CONSTANT_USER } from "@/utils/constant/user.ts";
import { CONSTANT_DEVICE } from "@/utils/constant/device.ts";
import { CONSTANT_STATUS } from "@/utils/constant/status.ts";
import { CONSTANT_SVG } from "@/utils/constant/svg.ts";
import { CONSTANT_NAVIGATOR } from "@/utils/constant/navigator.ts";
import { CesiumPosition } from "@/utils/constant/settings_constantes";

/** -------- ROOT FUNCTION -------- */

import ConfirmOpen from "@/utils/root/confirm_open";
import WatchVariable from "@/utils/root/watchVariable";
import MessageReplie from "@/utils/root/msg_replie_update";
import VideoStream from "@/utils/root/videoStream";
import Site from "@/utils/root/site";
import refreshMessage from "@/utils/root/refreshMessage";
import initTicket from "@/utils/root/initTicket";
import initQuery from "@/utils/root/initQuery";
import getVersion from "@/utils/root/getVersion";

/** --------------------- */

import APP_LOGIN from "@/app/login/APP_LOGIN.vue";
// ---
import APP_WEB from "@/app/web/APP_WEB.vue";
import APP_ADMIN from "@/app/admin/APP_ADMIN.vue";
import APP_MILESTONE from "@/app/milestone/APP_MILESTONE.vue";
import APP_PILOTLOGIN from "@/app/pilotlogin/APP_PILOTLOGIN.vue";
import APP_POPUP from "@/app/popup/APP_POPUP.vue";
// ---
import CONFIRM from "@/controller/Confirm.vue";
import EXTERNAL_CONTROL from "@/controller/ExternalControl.vue";
import DEVICE_CHEACKLIST from "@/controller/Device_Cheacklist.vue";
import DEVICE_APP from "@/controller/Device_App.vue";
// ---
import MapVue from "@/partials/Map/Map.vue";

export default {
  name: "App",
  components: {
    MapVue,
    APP_LOGIN,
    // ---APP_WEB
    APP_WEB,
    APP_ADMIN,
    APP_MILESTONE,
    APP_PILOTLOGIN,
    APP_POPUP,
    // ---
    EXTERNAL_CONTROL,
    DEVICE_CHEACKLIST,
    DEVICE_APP,
    CONFIRM,
  },

  setup() {
    const instance = getCurrentInstance();
    const $e = instance.appContext.config.globalProperties.$e;

    return {
      $e: $e,

      /** ------------------- */

      HUB: ref({}),

      /** ------------------- */

      application: ref("login"),
      login: ref(false),
      from: ref("web"),

      /** ------------------- */

      ...CONSTANT_USER.get(),
      ...CONSTANT_DEVICE.get(),
      ...CONSTANT_STATUS.get(),
      ...CONSTANT_SVG.get(),
      ...CONSTANT_NAVIGATOR.get(),

      /** ------------------- */

      toastConfig: ref({
        closeButton: true,
        autoClose: true,
        closeOnClick: true,
        position: toast.POSITION.TOP_CENTER,
        theme: "dark",
      }),

      toastMsgReplie: ref({
        closeButton: true,
        autoClose: false,
        closeOnClick: false,
        position: toast.POSITION.TOP_CENTER,
        theme: "dark",
      }),

      /** ------------------- */

      debug: ref(window.location.search == "?debug=1"),

      /** ------------------- */

      isPopup: ref(false),
      isPilotLogin: ref(false),
      isMilestonePlugin: ref(
        navigator.userAgent.includes("FlyingHub-Milestone") ||
          window.isMilestonePlugin ||
          ENV?.IS_MILESTONE_BROWSER ||
          window.location.search.includes("isMilestone")
      ),

      /** ------------------- */

      rcType: ref(false),

      /** ------------------- */

      user: ref({}),
      popups: ref({}),
      global: ref({}),
      confirm_data: ref(false),
      AppCanLoad: ref(false),
      pageLoad: ref(false),
      mapJsLoaded: ref(false),
      videoStream: ref({}),
      devices: ref({}),
      appClassSurcharge: ref(""),
      controller: ref(null),
      msg_replie: ref({}),
      Map_ShowOverlayElement: ref(true),

      /** ---------------- */

      tracker_type: ref({
        1: $e("Personne"),
        2: $e("Véhicule"),
      }),

      /** ---------------- */

      positionMap: ref({}),
      mainMapReady: ref(false),
      query: ref({}),

      /** ---------------- */
    };
  },

  beforeCreate() {
    /** ---------- QUERY ---------- */
    if (window.location.search != "") {
      let search = window.location.search.replace("?", "").split("&");
      search.forEach((el) => {
        let split = el.split("=");
        this.query[split[0]] = split[1];
      });
    }

    /** ---------- NAVIGATOR ---------- */
    let keys = Object.keys(this.navigator_rc);

    keys.forEach((key) => {
      if (navigator.userAgent.includes(this.navigator_rc[key])) {
        this.rcType = key;
      }
    });

    if (this.query.hasOwnProperty("debug_from")) {
      this.rcType = this.query.debug_from;
    }

    if (this.rcType !== false) {
      this.isPilotLogin = true;
    }

    /** ---------- INIT API ---------- */

    let user = new User(this);
    this.user = user;
    API.init(this.$root);
    this.login = this.user.isLog();

    /** ---------- FROM ---------- */
    if (this.isPilotLogin) {
      this.from = this.rcType;
    } else if (
      this.isMilestonePlugin ||
      this.query.hasOwnProperty("isMilestone")
    ) {
      this.from = "milestone";
    } else if (window.location.pathname.startsWith(ENV.PATH_POPUP)) {
      this.from = "popup";
      this.isPopup = true;
    }
    /** ---------- END FROM ---------- */

    /** ---------- APP ---------- */
    if (this.login) {
      this.user.startTimer();

      if (this.isPilotLogin) {
        this.application = "pilotlogin";
      }
      // else if (this.isPopup) {
      //   this.application = "popup";
      // }
      else {
        this.application = this.from;
      }
    }
    /** ---------- END APP ---------- */
  },

  beforeMount() {
    this.$root.global.site = {};
    this.$root.global.fetch = {};
    this.$root.global.fetch.msg_replie = 0;

    this.$root.global.media = {};

    this.$root.global.flightedit = {
      lstWarningsActions: [],
      lstWarningsDistances: [],
      missionActionUpdateList: [],
    };

    this.$root.global.contactOnline = [];

    Timer.initClock(this);
    this.initAllFonction();
  },

  async mounted() {
    /** ---------- INIT APIFRONTCONFIG  ---------- */
    if (this.login) {
      let frontconfig = await API.get("frontconfig");
      $root.frontconfig = frontconfig;
    }

    setTimeout(() => {
      this.AppCanLoad = true;
    }, 1000);
    /** -------------- */
    this.$root.setSite();
    /** -------------- */
  },

  beforeUnmount() {
    Timer.closeApp();
  },

  methods: {
    initAllFonction() {
      // --- ConfirmOpen --- //

      let confirmOpen = new ConfirmOpen(this);
      this.$root.confirm_open = confirmOpen.confirm_open;

      // --- WatchVariable --- //
      let watchVariable = new WatchVariable();
      this.$root.watchVariable = watchVariable;

      // --- MessageReplie --- //

      let messageReplie = new MessageReplie(this);
      messageReplie.init();

      // --- VideoStream --- //

      if (this.login) {
        let videoStream = new VideoStream(this);
        videoStream.init();
        this.$root.getVideoStream = videoStream.getVideoStream;
      }

      // --- Site --- //

      let site = new Site(this);
      this.$root.setSite = site.setSite;
      this.$root.addModels3DSite = site.addModels3DSite;
      this.$root.getGarageId = site.getGarageId;
      this.$root.setCustomArea = site.setCustomArea;
      this.$root.unloadCustomArea = site.unloadCustomArea;

      // ---

      getVersion();
      refreshMessage();
      initQuery(this);
      initTicket(this);
    },

    setpositionMap(CesiumPosition) {
      this.positionMap = CesiumPosition;
    },

    /** --- API --- */
    api_down() {
      this.$router.push({
        name: "Error_Api",
        params: {
          from: this.$router.fullPath,
        },
      });
    },
    /** --- END API --- */

    set_title(title) {
      document.title = ENV.SITE_TITLE + " - " + title;
    },

    reset_title() {
      document.title = ENV.SITE_TITLE;
    },
  },

  watch: {
    async $route(to, from) {
      if (Object.keys(this.$root.query).length > 0) {
        this.$router.replace({ query: this.query });
      }

      if (to.name == "APP_POPUP") {
        $root.isPopup = true;
      } else {
        $root.isPopup = false;
      }
    },
  },
};
</script>
